import React, { useState, useRef, useEffect } from 'react'
import { PROVIDER_COLORS } from '@constants/Providers'
import { ProviderColor } from '@dataTypes/provider.types'
import './CustomColorSelect.css'

type CustomColorSelectProps = {
  value: ProviderColor
  onChange: (color: ProviderColor) => void
  disabled?: boolean
}

const CustomColorSelect: React.FC<CustomColorSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const toggleDropdown = (): void => {
    if (disabled) return
    setIsOpen(!isOpen)
  }

  const handleSelect = (colorValue: ProviderColor): void => {
    if (disabled) return
    onChange(colorValue)
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const selectedColor = PROVIDER_COLORS.find(
    (color) => color.label === value.label,
  )

  return (
    <div
      className={`custom-color-select${disabled ? ' is-disabled' : ''}`}
      ref={dropdownRef}
      onClick={toggleDropdown}
    >
      <div className="selected-value">
        <span
          className="color-box"
          style={{ backgroundColor: selectedColor?.header }}
        ></span>
        {selectedColor?.label}
      </div>
      {isOpen && (
        <ul className="options">
          {PROVIDER_COLORS.map((color) => (
            <li
              key={`${color.header}-${color.background}-${color.text_color}`}
              onClick={() => handleSelect(color)}
            >
              <span
                className="color-box"
                style={{ backgroundColor: color.header }}
              ></span>
              {color.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default CustomColorSelect
